import { MarketListItem } from '../../../integrated-client/models'

export interface IMarketEditorData {
  marketData?: MarketListItem
  validation?: any
}
export class MarketEditorData implements IMarketEditorData {

  marketData?:  MarketListItem
  validation?: any
}